import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const EditContactListProModal = ({ open, list, onClose, onSuccess }) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && list) {
      setName(list.name || "");
    }
  }, [open, list]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = (name || "").trim();
    if (!trimmed) {
      toast.error("Informe o nome da lista.");
      return;
    }
    if (!list?.id) return;

    setLoading(true);
    try {
      await api.put(`/contact-lists-pro/${list.id}`, { name: trimmed });
      toast.success("Nome da lista atualizado!");
      onClose();
      if (onSuccess) onSuccess();
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  if (!list) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Editar nome da lista</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            label="Nome da lista"
            value={name}
            onChange={(e) => setName(e.target.value)}
            variant="outlined"
            margin="normal"
            disabled={loading}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={loading || !(name || "").trim()}
          >
            {loading ? "Salvando..." : "Salvar"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditContactListProModal;
